/** @jsx jsx */

import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { mobile, smDesktop, tablet } from './shared'
import { jsx } from 'theme-ui'

const Wrapper = styled.section`
  margin: 0 auto auto;
  width: 100%;
  max-width: ${props =>
    props.fullWidth ? 'none' : props.theme.sizes.pageMaxWidth};
  ${props =>
    !props.fullWidth &&
    css`
      padding: 1em 8em;
    `}
   
  
    ${props =>
      smDesktop(css`
        padding: ${!props.fullWidth && !props.fullWidthMobile
          ? '1em;'
          : '0px;'};
      `)}
      ${props =>
        mobile(css`
          padding: ${!props.fullWidth && !props.fullWidthMobile
            ? '1em;'
            : '0px;'};
        `)}
  flex-grow: 1;
`

const Container = props => {
  return <Wrapper {...props}>{props.children}</Wrapper>
}

export default Container
